import { render } from "./TwoFactor.vue?vue&type=template&id=0d0c26f6&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"

import "./TwoFactor.vue?vue&type=style&index=0&id=0d0c26f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0c26f6"]])

export default __exports__